import React from 'react';
import 'babel-polyfill';
import '@jg/raygun4js/dist/gg-raygun';
import { render } from 'react-dom';
import { browserHistory, Router } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { Provider } from 'react-redux';
import Tools, { initLogError } from 'utils/tools/tools';
import config from 'config/config';
import configureStore from './configureStore';
import facebookActions from './actions/facebookActions/facebookActions';
import createRoutes from './routes';
import { checkAuth } from './actions/authActions/authActions';
import apiActions from './actions/apiActions/apiActions';

try {
  const store = configureStore();
  const history = syncHistoryWithStore(browserHistory, store);

  initLogError();

  store.dispatch(facebookActions.facebookInitialise(config.FACEBOOK_APP_ID));
  store.dispatch(checkAuth());

  if (Tools.localStorageAvailable() && window.localStorage.getItem('selectedCharityEntity')) {
    const charityEntity = JSON.parse(window.localStorage.getItem('selectedCharityEntity'));
    if (charityEntity.charityId) {
      store.dispatch(apiActions.addCharityEntity(String(charityEntity.charityId), charityEntity));
    }
  }

  const mountNode = document.getElementById('app');

  render(
    <Provider store={store}>
      <Router history={history} routes={createRoutes(store)} />
    </Provider>,
    mountNode,
  );
} catch (e) {
  if (typeof window !== 'undefined' && window.rg4js) {
    window.rg4js('send', e);
  } else {
    console.error(e); // eslint-disable-line
  }
}



// WEBPACK FOOTER //
// ./client.js